<template>
  <label :class="{'invalid': returnInvalid}" for="password">
    <strong>Senha:</strong>
    <input type="password" v-model="password" />
    <small class="text-xs ml-2 text-red-500 hidden">mínimo 8 caracteres (letras e algarismos)</small>
  </label>
</template>

<script>
export default {
  name: 'InputPassword',
  data () {
    return {
      password: null
    }
  },
  computed: {
    returnInvalid () {
      let invalid = false
      if (this.password) {
        if (
          (this.password || '').length < 7 ||
          !(this.password.match(/[a-zA-Z0-9]/g) && this.password.match(/[0-9]/g) && this.password.match(/[a-zA-Z]/g))
        ) {
          invalid = true
        }
      }
      return invalid
    }
  },
  watch: {
    password (next) {
      if (!this.returnInvalid) {
        this.$emit('changed', next)
      } else {
        this.$emit('changed', null)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
label {
  input {
    @apply border border-gray-100 border-solid p-2 w-auto ml-2;
    &:focus {
      @apply border;
    }
  }
  &.invalid {
    input {
      @apply border-red-400
    }
    small {
      @apply inline
    }
  }
}
</style>
